import { withFuncFactory } from '../../libs/IdeLink.Web.Common/src/Factory';
import { CommunicationsPermissions } from '../modules/Communications/Services/CommunicationsPermissions';
import { OffersPermissions } from '../modules/Offers/Services/OffersPermissions';
import { OperationsPermissions } from '../modules/Operations/Services/OperationsPermissions';

/** //![permissionKey: string]: string; */
export type ApiPermissionsMap = Record<string, string>;

/**
 * Maps a permission key to the value that is used by the api.
 * Fluizy packaged orders are called `FluizyGoodDeals` but for irritalk they are called `IrritalkGoodDeals`.
 * To change the value, override `getApiPermissionsMapFactory`. For the [OffersPermissions.OFFERS_KEY] : value,
 * set the new value : Customer OffersPermissions Name
 */
export const GET_DEFAULT_API_PERMISSIONS_MAP = (): ApiPermissionsMap => ({
    //! OVERRIDED BY CUSTOMERS : Like Fluizy, Midas, Demolink, Irritalk,
    //* MODULES / PACKAGED ORDERS - TUNNABLED OFFERS - GOODDEALS
    [OffersPermissions.OFFERS_KEY]: OffersPermissions.OFFERS_NAME,

    //* MODULES / OPERATIONS - ENAGEMENTS
    [OperationsPermissions.OPERATIONS_KEY]: OperationsPermissions.OPERATIONS_NAME,

    //* MODULES / COMMUNICATIONS
    [CommunicationsPermissions.DIGITAL_MARKETINGS_KEY]:
        CommunicationsPermissions.DIGITAL_MARKETINGS_NAME,
    [CommunicationsPermissions.PARTNERSHIPS_KEY]: CommunicationsPermissions.PARTNERSHIPS_NAME,
    [CommunicationsPermissions.LEAFLETS_KEY]: CommunicationsPermissions.LEAFLETS_NAME,
});

const getDefaultApiPermissionsMap = (): ApiPermissionsMap => GET_DEFAULT_API_PERMISSIONS_MAP();
export const getApiPermissionsMapFactory = withFuncFactory(getDefaultApiPermissionsMap);
export const getApiPermissionName = (key: string) => getApiPermissionsMapFactory()[key];
